import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const JamforElbolag = lazy(() => import("@/pages/elbolag/Jamfor"));

export const Route = createFileRoute("/elbolag/jamfor")({
  head: () => seoHead("/elbolag/jamfor"),
  component: () => <JamforElbolag />,
});
